export const DEFAULT_SRC = '/gpa-product-store/';
export const TENANTLESS_SRC = '/gpa-product-store/tenantless.html';
export const SPA_APP_NAME = 'productStore';
